import React from 'react'
import {Icon} from '@chakra-ui/react'

const BurgerIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M4 5H36V8H4V5Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 18.5H36V21.5H4V18.5Z"
                fill="currentColor"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M4 32H26V35H4V32Z" fill="currentColor" />
        </Icon>
    )
}

export default BurgerIcon
